export default __webpack_public_path__ + "static/media/arrow_right_orange.54f02d30.svg";